import React, {useState, useEffect, useMemo} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {bannerData} from "../../../globals/banner";
import Banner from "../../sections/common/banner";
import {useNavigate} from "react-router-dom";
import {IoMdCloseCircle} from "react-icons/io";
import axios from "../../../api/axios";
import Footer from "../../sections/common/footer";
import HeaderMain from "../../sections/common/header";

const Modal = ({isOpen, onClose, children}) => {
    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div
            className="modal fade show"
            tabIndex="-1"
            role="dialog"
            style={{
                display: "block",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 1050,
            }}
            onClick={handleBackdropClick}
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div
                    className="modal-content"
                    onClick={(e) => e.stopPropagation()}
                    style={{zIndex: 1051}}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">
                            <strong>Select Entity</strong>
                        </h5>
                        <IoMdCloseCircle
                            className="close"
                            style={{cursor: "pointer"}}
                            onClick={onClose}
                        />
                    </div>
                    <div className="modal-body">{children}</div>
                </div>
            </div>
        </div>
    );
};

const AuthModal = ({isOpen, onClose, children}) => {
    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div
            className="modal fade show"
            tabIndex="-1"
            role="dialog"
            style={{
                display: "block",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 1060,
            }}
            onClick={handleBackdropClick}
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div
                    className="modal-content"
                    onClick={(e) => e.stopPropagation()}
                    style={{zIndex: 1061}}
                >
                    <div className="modal-header d-flex justify-content-between">
                        <h5 className="modal-title">
                            <strong>Are you already a customer?</strong>
                        </h5>
                        <IoMdCloseCircle
                            className="close"
                            style={{cursor: "pointer"}}
                            onClick={onClose}
                        />
                    </div>
                    <div className="modal-body">{children}</div>
                </div>
            </div>
        </div>
    );
};

const ProductCard = ({
                         product,
                         onSelectProduct,
                         handleUseItClick,
                         isAuthenticated,
                     }) => {
    const handleWatchDemo = (demoUrl) => {
        if (demoUrl) {
            window.open(demoUrl, "_blank");
        }
    };

    const availableOnPlatforms = JSON.parse(product.available_on || "[]");

    const handleProductAction = (e) => {
        e.preventDefault();

        if (isAuthenticated) {
            onSelectProduct(product);
        } else {
            handleUseItClick();
        }
    };

    const getPlatformIcon = (platform) => {
        switch (platform) {
            case "mobile":
                return "/assets/images/phoneicon.png";

            case "desktop":
                return "/assets/images/desktop.png";

            case "web":
                return "/assets/images/desktop.png";

            default:
                return "/assets/images/desktop.png";
        }
    };

    return (
        <div
            className="card w-100 border-0"
            style={{
                borderRadius: "20px",
                overflow: "hidden",
                background:
                    "linear-gradient(180deg, #fff8ec 0%, #fff0d8 100%)",
                boxShadow: "0 8px 24px rgba(255, 165, 0, 0.1)",
                border: "1px solid rgba(255, 165, 0, 0.16)",
                transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow =
                    "0 12px 30px rgba(255, 165, 0, 0.16)";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow =
                    "0 8px 24px rgba(255, 165, 0, 0.1)";
            }}
        >
            <div className="card-body p-4 d-flex flex-column">

                {/* Header */}
                <div className="d-flex align-items-start gap-3 mb-3">
                    <div
                        style={{
                            width: "64px",
                            height: "64px",
                            minWidth: "64px",
                            borderRadius: "16px",
                            background: "#fffdf8",
                            border: "2px solid #f0a126",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <img
                            src={product.icon}
                            alt={product.product_name}
                            style={{
                                width: "38px",
                                height: "38px",
                                objectFit: "contain",
                            }}
                        />
                    </div>

                    <div className="flex-grow-1">
                        <h4
                            className="fw-bold mb-1"
                            style={{
                                fontSize: "1.55rem",
                                color: "#172033",
                            }}
                        >
                            {product.product_name}
                        </h4>

                        <p
                            className="mb-0"
                            style={{
                                fontSize: "15px",
                                lineHeight: "1.5",
                            }}
                        >
                            {product.description}
                        </p>
                    </div>
                </div>

                {/* Platform + Pricing */}
                <div
                    className="d-flex justify-content-between align-items-center flex-wrap gap-3 py-3"
                    style={{
                        borderTop: "1px solid rgba(0,0,0,0.07)",
                        borderBottom: "1px solid rgba(0,0,0,0.07)",
                    }}
                >
                    {/* Platforms */}
                    <div className="d-flex flex-wrap gap-2">
                        {availableOnPlatforms.map((platform, index) => (
                            <span
                                key={index}
                                className="d-inline-flex align-items-center gap-2 px-3 py-2"
                                style={{
                                    borderRadius: "999px",
                                    background: "#fffdf9",
                                    border: "1px solid rgba(0,0,0,0.06)",
                                    fontSize: "12px",
                                    color: "#273142",
                                    whiteSpace: "nowrap",
                                }}
                            >
                <img
                    src={getPlatformIcon(platform)}
                    alt={platform}
                    style={{
                        width: "15px",
                        height: "15px",
                        objectFit: "contain",
                    }}
                />

                                {platform.charAt(0).toUpperCase() + platform.slice(1)}
              </span>
                        ))}
                    </div>

                    {/* Pricing */}
                    {product.yearly_price && (
                        <div className="text-end ms-auto">
                            <div
                                className="fw-bold"
                                style={{
                                    color: "#e89a22",
                                    fontSize: "1.75rem",
                                    lineHeight: "1",
                                }}
                            >
                                ₹{Number(product.yearly_price).toLocaleString("en-IN")}
                            </div>

                            <small
                                style={{
                                    fontSize: "11px",
                                    color: "#6b7280",
                                }}
                            >
                                / year
                            </small>
                        </div>
                    )}
                </div>

                {/* Actions */}
                <div className="pt-3">

                    {/* Demo */}
                    {product.video_url && (
                        <button
                            className="btn w-100 mb-3 fw-semibold d-flex align-items-center justify-content-center gap-2"
                            style={{
                                borderRadius: "12px",
                                padding: "10px",
                                background: "#fffdfa",
                                border: "1px solid rgba(0,0,0,0.08)",
                                color: "#111827",
                                transition: "all 0.2s ease",
                            }}
                            onClick={() => handleWatchDemo(product.video_url)}
                        >
                            <span style={{fontSize: "14px"}}>▶</span>
                            Watch Demo
                        </button>
                    )}

                    {/* Primary Actions */}
                    <div className="d-flex gap-2 mb-2">
                        <button
                            className="btn flex-fill fw-semibold"
                            style={{
                                borderRadius: "12px",
                                padding: "10px",
                                border: "1.5px solid #efa329",
                                color: "#e99a1f",
                                background: "#fffaf2",
                                transition: "all 0.2s ease",
                            }}
                            onClick={handleProductAction}
                        >
                            Subscribe Now
                        </button>

                        <button
                            className="btn flex-fill fw-semibold"
                            style={{
                                borderRadius: "12px",
                                padding: "10px",
                                background:
                                    "linear-gradient(135deg, #f5b23f 0%, #e99b22 100%)",
                                color: "#fff",
                                border: "none",
                                boxShadow: "0 5px 12px rgba(233, 155, 34, 0.2)",
                                transition: "all 0.2s ease",
                            }}
                            onClick={handleProductAction}
                        >
                            Schedule Discussion
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};


const ProductGrid = () => {
    const [products, setProducts] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [entity, setEntity] = useState([]);
    const [selectedRestaurant, setSelectedRestaurant] = useState("");
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [subscriptionType, setSubscriptionType] = useState("Trial");
    const [customAmount, setCustomAmount] = useState("");
    const [amount, setAmount] = useState(0);
    const [selectedRestaurantGroupId, setSelectedRestaurantGroupId] =
        useState(null);
    const [showAuthDialog, setShowAuthDialog] = useState(false);
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(() =>
        sessionStorage.getItem("isAuthenticated"),
    );
    const [userData, setUserData] = useState(() => {
        const stored = sessionStorage.getItem("userData");
        return stored ? JSON.parse(stored) : null;
    });

    const groupId = useMemo(() => {
        return userData?.Group_ID;
    }, [userData?.Group_ID]);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await axios.post(
                    `businessEntities/getAllProductsAndPlans`,
                    {
                        userid: userData?.userId || null,
                    },
                    {
                        headers: {"Content-Type": "application/json"},
                        withCredentials: false,
                    },
                );
                setProducts(response.data.products || []);
            } catch (error) {
                console.log("❌ [useEffect #1] Error fetching products. " + error);
            }
        };

        fetchProducts();
    }, [userData?.userId]);


    useEffect(() => {
        (async () => {
            await axios.post(`/tracking/set-product-visit`);
        })();
    }, []);

    useEffect(() => {
        const fetchBusinessEntities = async () => {
            console.log(
                "📡 [useEffect #2] Starting business entities fetch for groupId:",
                groupId,
            );
            try {
                const response = await axios.get(
                    `businessEntities/getAllBusinessEntities/${groupId || null}`,
                );
                console.log(
                    "🏪 [useEffect #2] Business entities fetched successfully:",
                    response.data?.length || 0,
                    "entities",
                );
                setEntity(response.data || []);
                console.log("entity", response.data);
            } catch (error) {
                console.log(
                    "❌ [useEffect #2] Error fetching business entities. " + error,
                );
            }
        };

        if (userData) {
            fetchBusinessEntities();
        } else {
            console.log("⏸️ [useEffect #2] Skipping fetch - no userData available");
        }
    }, [groupId, userData]);

    const handleUseItClick = () => {
        setShowAuthDialog(true);
    };

    const handleLogin = () => {
        navigate("/login");
    };

    const handleRegister = () => {
        navigate("/registration");
    };

    const handleRestaurantChange = (e) => {
        const selectedId = e.target.value;
        setSelectedRestaurant(selectedId);

        const selected = entity.find(
            (r) => r.business_entity_id.toString() === selectedId,
        );
        if (selected) {
            setSelectedRestaurantGroupId(selected.group_id);
        }
    };

    const handleSelectProduct = (product) => {
        setSelectedProduct(product);
        setSubscriptionType("Trial");
        setAmount(0);
        setIsModalOpen(true);
    };

    const handleSubmitSubscription = async () => {
        console.log(selectedRestaurant, selectedProduct, selectedRestaurantGroupId);

        if (selectedRestaurant) {
            try {
                const response = await axios.post(
                    `businessEntities/addProductForBusiness`,
                    {
                        businessEntityId: selectedRestaurant,
                        productId: selectedProduct.product_id,
                        groupId: selectedRestaurantGroupId
                    },
                );
                console.log("Product added to entity:", response.data);
                alert("Product added successfully!");
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    alert(error.response.data.error || "Product is already registered");
                } else if (error.response) {
                    alert(
                        `Failed to add product: ${error.response.data.message || error.response.data || "Server error"}`,
                    );
                } else if (error.request) {
                    alert(
                        "Failed to add product: No response from server. Please check your connection.",
                    );
                } else {
                    alert("Failed to add product: An unexpected error occurred.");
                }
            }
        }
        setSelectedRestaurant("");
        setIsModalOpen(false);
    };

    const handleModalClose = () => {
        setSelectedRestaurant("");
        setIsModalOpen(false);
    };

    return (
        <>
            <div className="page-wraper">
                {<HeaderMain/>}
                <div className="page-content">
                    <Banner _data={bannerData.products}/>
                    <div className="container py-5">
                        <div className="row g-4 justify-content-center">
                            {products.map((product) => (
                                <div
                                    key={product.product_id}
                                    className="col-12 col-md-6 col-xl-4 d-flex"
                                >
                                    <ProductCard
                                        product={product}
                                        onSelectProduct={handleSelectProduct}
                                        handleUseItClick={handleUseItClick}
                                        isAuthenticated={isAuthenticated}
                                    />
                                </div>
                            ))}
                        </div>

                        {showAuthDialog && (
                            <AuthModal
                                isOpen={showAuthDialog}
                                onClose={() => setShowAuthDialog(false)}
                            >
                                <div className="modal-body">
                                    <button
                                        className="btn btn-primary w-100 mb-2"
                                        onClick={handleLogin}
                                    >
                                        Login
                                    </button>
                                    <button
                                        className="btn btn-secondary w-100"
                                        onClick={handleRegister}
                                    >
                                        Register
                                    </button>
                                </div>
                            </AuthModal>
                        )}
                    </div>

                    <Modal isOpen={isModalOpen} onClose={handleModalClose}>
                        <div className="p-4">
                            {/* Header with icon */}
                            <div className="text-center mb-4">
                                <div
                                    className="mx-auto mb-3 d-inline-flex align-items-center justify-content-center rounded-circle bg-warning bg-opacity-10"
                                    style={{width: "60px", height: "60px"}}
                                >
                                    <svg
                                        width="28"
                                        height="28"
                                        viewBox="0 0 24 24"
                                        fill="#FFA500"
                                    >
                                        <path
                                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                                    </svg>
                                </div>
                                <h5 className="modal-title fw-bold mb-2">
                                    Link Product to Entity
                                </h5>
                                <p className="text-muted mb-0" style={{fontSize: "14px"}}>
                                    Choose the business entity where you want to activate this
                                    product
                                </p>
                            </div>

                            {/* Enhanced Select Dropdown */}
                            <div className="mb-4">
                                <label className="form-label fw-semibold text-dark d-flex align-items-center mb-2">
                                    <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        className="me-2"
                                        style={{color: "#FFA500"}}
                                    >
                                        <path
                                            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                                    </svg>
                                    Select Business Entity
                                </label>
                                <div className="position-relative">
                                    <select
                                        value={selectedRestaurant}
                                        onChange={handleRestaurantChange}
                                        className="form-select form-select-lg border-2 bg-light"
                                        style={{
                                            borderRadius: "12px",
                                            borderColor: "#FFA500",
                                            padding: "12px 45px 12px 15px",
                                            fontSize: "16px",
                                            transition: "all 0.3s ease",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <option value="">Choose an entity...</option>
                                        {entity
                                            .filter(
                                                (it) =>
                                                    it?.business_type ===
                                                    selectedProduct?.business_type ||
                                                    selectedProduct?.business_type === "ALL",
                                            )
                                            .map((res) => (
                                                <option
                                                    key={res.business_entity_id}
                                                    value={res.business_entity_id}
                                                >
                                                    {res.business_name}
                                                </option>
                                            ))}
                                    </select>
                                    <div
                                        className="position-absolute top-50 end-0 translate-middle-y me-3 pointer-events-none">
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="#FFA500"
                                        >
                                            <path d="M7 10l5 5 5-5z"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            {/* Enhanced Submit Button */}
                            <button
                                className="btn btn-warnings w-100 fw-semibold py-3 mb-4 d-flex align-items-center justify-content-center gap-2"
                                style={{
                                    borderRadius: "12px",
                                    fontSize: "16px",
                                    background:
                                        "linear-gradient(135deg, #FFA500 0%, #FF8C00 100%)",
                                    border: "none",
                                    transition: "all 0.3s ease",
                                    boxShadow: "0 4px 15px rgba(255, 165, 0, 0.3)",
                                }}
                                onClick={handleSubmitSubscription}
                                onMouseOver={(e) => {
                                    e.target.style.transform = "translateY(-2px)";
                                    e.target.style.boxShadow =
                                        "0 6px 20px rgba(255, 165, 0, 0.4)";
                                }}
                                onMouseOut={(e) => {
                                    e.target.style.transform = "translateY(0)";
                                    e.target.style.boxShadow =
                                        "0 4px 15px rgba(255, 165, 0, 0.3)";
                                }}
                                disabled={!selectedRestaurant}
                            >
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                >
                                    <path
                                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                                </svg>
                                Link Product to Entity
                            </button>

                            {/* Simple Notice */}
                            <div className="alert alert-warning d-flex align-items-center p-3 rounded-3 mb-0">
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="#FFA500"
                                    className="me-2 flex-shrink-0"
                                >
                                    <path
                                        d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"/>
                                </svg>
                                <div>
                                    <strong className="text-dark">Next Steps:</strong>
                                    <div className="text-dark small">
                                        Contact our agent for product activation (usually within 24
                                        hours)
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
                {<Footer/>}
                <button className="scroltop">
                    <span className="fa fa-angle-up relative" id="btn-vibrate"></span>
                </button>
            </div>
        </>
    );
};

export default ProductGrid;
